import React from 'react';

import { di } from 'react-magnetic-di';

import { Box } from '@atlaskit/primitives/compiled/box';
import TextArea from '@atlaskit/textarea/text-area';

import { asFormTextField } from '../../../../../../../../common/types/form/form-fields/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import { useFormField } from '../../../../../../../../controllers/form-renderer-store';

export const PreviewParagraphPlainInput = ({
	fieldId,
	fieldInputId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormField);
	const formField = useFormField({ fieldId });
	const formTextAreaField = asFormTextField(formField);

	if (formTextAreaField === undefined) {
		return <></>;
	}

	return (
		<Box testId={`field-input-paragraph-plain-preview-${fieldId}`}>
			<TextArea
				id={fieldInputId}
				value={formTextAreaField.value?.text}
				isDisabled
				minimumRows={5}
			/>
		</Box>
	);
};
